export const errorCodes = {
  '403': '403: Forbidden',
  '404': '404: Not Found',
  '422': '422: Unprocessable Entity',
};
